import Date from "common/values/date/date";
import Guid from "common/values/guid/guid";
import moment from "moment";
import ResourceInfoAPIResponse from "permissions/entities/permission/api/response-contracts/resource-info-api-response";
import PermissionTemplate from "permissions/entities/permission/permission-template";
import { Resource } from "permissions/entities/permission/resources/general";

export default class PermissionTemplateAPIResponse {
  public id?: string;
  public userId?: string;
  public resources?: ResourceInfoAPIResponse[];
  public name?: string;
  public description?: string;
  public createdDate?: string;
  public deletedDate?: string;

  public async deserialize<T extends Resource>(): Promise<PermissionTemplate> {
    if (!this.id) {
      throw new Error("Invalid PermissionTemplateAPIResponse: id must be defined");
    }
    if (!this.userId) {
      throw new Error("Invalid PermissionTemplateAPIResponse: userId must be defined");
    }
    if (!this.resources) {
      throw new Error("Invalid PermissionTemplateAPIResponse: resources must be defined");
    }
    if (!this.name) {
      throw new Error("Invalid PermissionTemplateAPIResponse: name must be defined");
    }

    const resourcesInfo = this.resources.map(resource => 
      Object.assign(new ResourceInfoAPIResponse(), resource)
    );
    const concreteResources = await Promise.all(
      resourcesInfo.map(resource => resource.deserialize<T>())
    );

    return new PermissionTemplate(
      new Guid(this.id),
      new Guid(this.userId),
      concreteResources,
      this.name,
      this.description,
      new Date(moment(this.createdDate)),
      new Date(moment(this.deletedDate))
    );
  }
}
